import {AppProviders} from './modules/common/providers'
import {AppRoutes} from './modules/routing'

interface AppProps {
  // Injected by the host app so refra does not import sibling feature packages.
  catalogElement: React.ReactElement
}

export const App: React.FC<AppProps> = ({catalogElement}) => {
  return (
    <AppProviders>
      <AppRoutes catalogElement={catalogElement} />
    </AppProviders>
  )
}
